export const votingStore = {
    state: () => ({
        isShowAddVotingModal: false,
        isShowInteractiveVotingModal: false,
        selectedVoting: null,
        isSessionEnd: false,
        votingMode: "standard",
        votingPoints: [],
        sessionId: 0,
        selectedPoint: {
            id: 0,
            name: ''
        },
        isCopyVoting: false,
        saveVotingStatus: false,
        startVotingStatus: false,
        startVotingData: null,
        isRoomMapAddVotingCall: false,
        isRoomMapInteractiveVotingCall: false,
        openAutomatic: false,
        saveInteractiveVotingStatus: false,
        saveInteractiveVotingData: null,
        interactiveVotingModalInAppStatus: false,
        isShowInteractiveVotingResultsModal: false,
        fromEndVotingCall: false,
        isPublicViewCall: false,
        isResultsInVisualization: {
            value: false,
            tick: 0,
        },
        votingChartData: null,
        votingInternalBasicData: null,
        votingPossibleAnswersData: null,
        isCanClose: false
    }),
    mutations: {
        setStartVotingStatus(state, value) {
            if (value === false) {
                state.startVotingData = null
            }

            state.startVotingStatus = value
        },
        setStartVotingData(state, payload) {
            state.startVotingData = payload
        },
        setIsShowAddVotingModalStatus(state, status) {
            if (status === false) {
                state.selectedVoting = null;
                state.votingPoints = [];
                state.votingMode = "standard";
                state.isSessionEnd = false;
                state.sessionId = 0;
                state.selectedPoint = {
                    id: 0,
                    name: ''
                };
                state.isCopyVoting = false;
                state.isRoomMapAddVotingCall = false;
            }
            state.isShowAddVotingModal = status;
        },
        setIsSessionEndStatus(state, status) {
            state.isSessionEndStatus = status;
        },
        setVotingMode(state, status) {
            state.votingMode = status;
        },
        setVotingPoints(state, status) {
            state.votingPoints = status;
        },
        setVotingSessionId(state, status) {
            state.sessionId = status;
        },
        setSelectedVotingId(state, status) {
            state.selectedVoting = status;
        },
        setSelectedVotingPointId(state, status) {
            state.selectedPoint = status;
        },
        setIsCopyVotingStatus(state, status) {
            state.isCopyVoting = status;
        },
        setSaveVotingStatus(state, status) {
            state.saveVotingStatus = status;
        },
        setIsRoomMapAddVotingCallStatus(state, status) {
            state.isRoomMapAddVotingCall = status;
        },
        setIsRoomMapInteractiveVotingCallStatus(state, status) {
            state.isRoomMapInteractiveVotingCall = status;
        },
        setIsShowInteractiveVotingModalStatus(state, status) {
            if (status === false) {
                state.sessionId = 0;
                state.selectedPoint = {
                    id: 0,
                    name: ''
                };
                state.selectedVoting = null;
                state.openAutomatic = false;
                state.isRoomMapInteractiveVotingCall = false;
            }
            state.isShowInteractiveVotingModal = status;
        },
        setVotingOpenAutomaticStatus(state, status) {
            state.openAutomatic = status;
        },
        setSaveInteractiveVotingStatus(state, status) {
            if (status === false) {
                state.saveInteractiveVotingData = null;
            }
            state.saveInteractiveVotingStatus = status;
        },
        setSaveInteractiveVotingData(state, payload) {
            state.saveInteractiveVotingData = payload
        },
        setInteractiveVotingModalInAppStatus(state, payload) {
            state.interactiveVotingModalInAppStatus = payload
        },
        setIsShowInteractiveVotingResultsModalStatus(state, status) {
            if (status === false) {
                state.fromEndVotingCall = false;
                state.isPublicViewCall = false;
                state.sessionId = 0;
                state.selectedPoint = {
                    id: 0,
                    name: ''
                };
                state.selectedVoting = null;
                state.isResultsInVisualization = false;
                state.votingChartData = null;
                state.votingInternalBasicData = null;
                state.votingPossibleAnswersData = null;
            }
            state.isShowInteractiveVotingResultsModal = status;
        },
        setFromEndVotingCallStatus(state, status) {
            state.fromEndVotingCall = status;
        },
        setIsPublicViewCallStatus(state, status) {
            state.isPublicViewCall = status;
        },
        setIsResultsInVisualization(state, payload) {
            state.isResultsInVisualization = {
                value: payload,
                tick: Date.now(),
            };
        },
        setVotingChartData(state, status) {
            state.votingChartData = status;
        },
        setVotingInternalBasicData(state, status) {
            state.votingInternalBasicData = status;
        },
        setVotingPossibleAnswersData(state, status) {
            state.votingPossibleAnswersData = status;
        },
        setCanCloseStatus(state, status) {
            state.isCanClose = status;
        },
    }
}